(() => {
  const pacificClock = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  function pacificParts(time) {
    return Object.fromEntries(pacificClock.formatToParts(time).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  }
  function nextPacificMidnight(now) {
    const local = pacificParts(now);
    const target = Date.UTC(local.year, local.month - 1, local.day + 1);
    let midnight = target + 8 * 60 * 60 * 1000;
    // Resolve the UTC offset at the target midnight, including DST changes.
    for (let pass = 0; pass < 3; pass++) {
      const parts = pacificParts(midnight);
      const wallTime = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      const resolved = target - (wallTime - midnight);
      if (resolved === midnight) return midnight;
      midnight = resolved;
    }
    return midnight;
  }
  function nextTwoHourBoundary(now) {
    const interval = 2 * 60 * 60 * 1000;
    return (Math.floor(now / interval) + 1) * interval;
  }
  function init(root) {
    if (root.dataset.nv11Ready) return;
    root.dataset.nv11Ready = 'true';
    root.addEventListener('change', event => {
      const input = event.target.closest('[data-nv7-pack] input');
      if (!input) return;
      const hasSaving = Number(input.dataset.saving) > 0;
      root.querySelectorAll('[data-nv7-offers]').forEach(offers => {
        ['[data-nv11-saving-panel]', '[data-nv11-basis-wrap]', '[data-nv11-badge]'].forEach(selector => offers.querySelectorAll(selector).forEach(el => { el.hidden = !hasSaving; }));
        const pairs = {'[data-nv11-saving]':'savingLabel','[data-nv11-saving-basis]':'basisLabel','[data-nv11-saving-percent]':'percentLabel','[data-nv11-badge-label]':'badgeLabel','[data-nv11-basis]':'basis'};
        Object.entries(pairs).forEach(([selector, key]) => offers.querySelectorAll(selector).forEach(el => { el.textContent = input.dataset[key]; if (selector === '[data-nv11-basis]') el.hidden = !hasSaving; }));
        offers.querySelectorAll('[data-nv11-saving-fill]').forEach(el => { el.style.width = Math.max(0, Math.min(100, Number(input.dataset.savingPercent))) + '%'; });
      });
    });
    const countdowns = [...root.querySelectorAll('[data-nv11-countdown]')];
    const dailyEnds = new WeakMap();
    let timer;
    const update = () => {
      let active = false;
      const now = Date.now();
      countdowns.forEach(card => {
        const daily = card.dataset.mode === 'daily';
        const twoHour = card.dataset.mode === 'two-hour';
        let end = twoHour ? nextTwoHourBoundary(now) : daily ? dailyEnds.get(card) : Date.parse(card.dataset.deadline);
        if (daily && (!end || end <= now)) {
          end = nextPacificMidnight(now);
          dailyEnds.set(card, end);
        }
        const seconds = daily || twoHour ? Math.ceil((end - now) / 1000) : Math.floor((end - now) / 1000);
        if (!Number.isFinite(seconds) || seconds <= 0) { card.hidden = true; return; }
        active = true; card.hidden = false;
        const pad = value => String(value).padStart(2, '0');
        card.querySelector('[data-nv11-hours]').textContent = pad(Math.floor(seconds / 3600));
        card.querySelector('[data-nv11-minutes]').textContent = pad(Math.floor(seconds % 3600 / 60));
        card.querySelector('[data-nv11-seconds]').textContent = pad(seconds % 60);
      });
      if (!active && timer) clearInterval(timer);
    };
    if (countdowns.length) { timer = setInterval(update, 1000); update(); }
    root.nv11Cleanup = () => clearInterval(timer);
  }
  document.querySelectorAll('[data-nv7]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-nv7]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-nv7]').forEach(root => root.nv11Cleanup?.()));
})();
